/**
 * Custom mobile menu icons + scroll fix
 * -------------------------------------
 * Adds an outline icon (same colour as the link text) beside each item
 * in the hamburger/mobile menu, and fixes the drawer so items like
 * "BLOGS" no longer get cut off at the bottom.
 *
 * HOW TO INSTALL (Shopify Admin):
 * 1. Online Store > Themes > your theme > Edit code
 * 2. Under "Assets", click "Add a new asset" > "Create a blank file"
 *    Name it: menu-icons.js  (paste this whole file in and Save)
 * 3. Open layout/theme.liquid, find the closing </body> tag, and just
 *    above it add:
 *      <script src="{{ 'menu-icons.js' | asset_url }}" defer></script>
 * 4. Save. Reload your storefront and open the hamburger menu.
 *
 * IF ICONS DON'T APPEAR:
 * Your menu drawer's container may use a different class name than the
 * default guess below. Right-click the hamburger menu > Inspect, find
 * the element that wraps ALL the menu links (HOME, ARABIC, FLOWERS...),
 * copy its class, and paste it into DRAWER_SELECTORS below.
 */

(function () {
  "use strict";

  // ---- 1. CONFIG: adjust if icons don't show up automatically ----
  var DRAWER_SELECTORS = [
    "menu-drawer",
    ".menu-drawer",
    "#menu-drawer",
    ".header-drawer",
    ".mobile-menu",
    "[data-menu-drawer]",
    "nav[aria-label='Main']" // fallback, generic
  ];

  // Match by the exact visible text of each menu link (case-insensitive).
  var ICONS = {
    "HOME": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 11.5L12 4l8.5 7.5"/><path d="M5.5 10v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9"/><path d="M9.5 20v-6h5v6"/></svg>',

    "ARABIC": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16.5c0-3 2.6-5 6-5h3.3c1.9 0 3.4-1.1 3.4-2.6 0-.9-.6-1.7-1.4-2.1"/><path d="M4 16.5c0 1.7 2.7 3 6.2 3h1.6c3.5 0 6.7-1.3 6.7-3s-3.2-3-6.7-3"/><path d="M2 16.5h2M18.5 16.5h1.5"/><path d="M15.6 5.6c.9.3 1.6-.3 1.4-1.3"/></svg>',

    "FLOWERS": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="4.5" r="2.1"/><circle cx="15.6" cy="6.3" r="2.1"/><circle cx="15.6" cy="10" r="2.1"/><circle cx="8.4" cy="6.3" r="2.1"/><circle cx="8.4" cy="10" r="2.1"/><circle cx="12" cy="8" r="1.4"/><line x1="12" y1="10" x2="12" y2="19.5"/><path d="M12 15l-3 2M12 16l3 2"/></svg>',

    "GOURMAND": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="7.5" y="9" width="9" height="6" rx="2.2"/><path d="M7.5 10.2l-4-2.2v8l4-2.2"/><path d="M16.5 10.2l4-2.2v8l-4-2.2"/></svg>',

    "INSPIRED": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l3-5h6l3 5"/><path d="M6 9l6 11 6-11"/><path d="M6 9h12"/><path d="M9.4 9l2.6 11 2.6-11"/></svg>',

    "OLD IS GOLD": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 20v-6a3 3 0 0 1 6 0v6"/><path d="M8 12.3a4 4 0 0 1 8 0"/><line x1="12" y1="4.2" x2="12" y2="8"/><circle cx="12" cy="3" r="1"/><rect x="4" y="16" width="2" height="4"/><rect x="18" y="16" width="2" height="4"/><line x1="4" y1="14" x2="4" y2="16"/><line x1="20" y1="14" x2="20" y2="16"/><circle cx="4" cy="13" r="1"/><circle cx="20" cy="13" r="1"/><line x1="3" y1="20" x2="21" y2="20"/></svg>',

    "ROYAL OUDH": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21V10M12 21V8M15 21V10"/><path d="M9 10c-1-1-1-2 0-3M12 8c-1-1-1-2.5 0-3.5M15 10c1-1 1-2 0-3"/><ellipse cx="12" cy="21" rx="6" ry="1.3"/></svg>',

    "ROYAL OUDH(S)": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21V10M12 21V8M15 21V10"/><path d="M9 10c-1-1-1-2 0-3M12 8c-1-1-1-2.5 0-3.5M15 10c1-1 1-2 0-3"/><ellipse cx="12" cy="21" rx="6" ry="1.3"/></svg>',

    "BLOGS": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5c1.4-.8 3-1.2 4.5-1.2S11.6 4.7 12 5.5c.4-.8 2-1.2 3.5-1.2s3.1.4 4.5 1.2v13c-1.4-.8-3-1.2-4.5-1.2s-3.1.4-3.5 1.2c-.4-.8-2-1.2-3.5-1.2S5.4 17.7 4 18.5z"/><path d="M12 5.5v13"/></svg>',

    "BLOG": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5c1.4-.8 3-1.2 4.5-1.2S11.6 4.7 12 5.5c.4-.8 2-1.2 3.5-1.2s3.1.4 4.5 1.2v13c-1.4-.8-3-1.2-4.5-1.2s-3.1.4-3.5 1.2c-.4-.8-2-1.2-3.5-1.2S5.4 17.7 4 18.5z"/><path d="M12 5.5v13"/></svg>'
  };

  // ---- 2. Inject styles (icon sizing + drawer scroll fix) ----
  var style = document.createElement("style");
  style.textContent = [
    ".mi-icon{display:inline-flex;align-items:center;justify-content:center;",
    "width:1.15em;height:1.15em;margin-right:.55em;flex:0 0 auto;",
    "vertical-align:-0.2em;color:inherit;}",
    ".mi-icon svg{width:100%;height:100%;display:block;}",
    ".mi-has-icon{display:inline-flex !important;align-items:center;}",

    /* Left-align all menu text (Horizon sometimes centers drawer links). */
    "menu-drawer, .menu-drawer, #menu-drawer, .header-drawer, .mobile-menu{",
    "  text-align: left !important;",
    "}",
    "menu-drawer a, .menu-drawer a, #menu-drawer a, ",
    ".header-drawer a, .mobile-menu a, ",
    "menu-drawer li, .menu-drawer li, #menu-drawer li{",
    "  text-align: left !important;",
    "  justify-content: flex-start !important;",
    "  width: 100% !important;",
    "  display: flex !important;",
    "}",

    /* Scroll fix: make the drawer's own link list scrollable so
       the last items (e.g. BLOGS) are reachable instead of being
       clipped behind the fixed bottom bar. Adjust the 64px/64px
       values below if your header/footer bars are a different height. */
    "menu-drawer, .menu-drawer, #menu-drawer, .header-drawer, .mobile-menu{",
    "  overflow: hidden !important;",
    "}",
    "menu-drawer nav, .menu-drawer nav, #menu-drawer nav, ",
    ".header-drawer nav, .mobile-menu nav, ",
    "menu-drawer ul, .menu-drawer ul, #menu-drawer ul{",
    "  max-height: calc(100dvh - 64px - 64px) !important;",
    "  overflow-y: auto !important;",
    "  -webkit-overflow-scrolling: touch !important;",
    "  padding-bottom: 24px !important;",
    "}"
  ].join("\n");
  document.head.appendChild(style);

  // ---- 3. Find the drawer and add icons ----
  function findDrawer() {
    for (var i = 0; i < DRAWER_SELECTORS.length; i++) {
      var el = document.querySelector(DRAWER_SELECTORS[i]);
      if (el) return el;
    }
    return document; // last resort: search the whole page
  }

  function normalize(text) {
    return (text || "").replace(/\s+/g, " ").trim().toUpperCase();
  }

  function addIcons() {
    var root = findDrawer();
    var links = root.querySelectorAll("a");
    links.forEach(function (link) {
      if (link.dataset.miIconAdded) return; // already processed

      // Use the link's own text, ignoring any icon/span we've already added
      var label = normalize(link.textContent);
      var svg = ICONS[label];
      if (!svg) return;

      var wrap = document.createElement("span");
      wrap.className = "mi-icon";
      wrap.innerHTML = svg;

      link.classList.add("mi-has-icon");
      link.insertBefore(wrap, link.firstChild);
      link.dataset.miIconAdded = "true";
    });
  }

  // Run once DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", addIcons);
  } else {
    addIcons();
  }

  // Re-run whenever the drawer opens or its content changes
  // (Shopify drawers are often re-rendered / toggled via classes).
  var observer = new MutationObserver(function () {
    addIcons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();